import './accordion.css';
import './accordion.html.twig';

export default function() {

  const acc = document.querySelectorAll('.accordion__control');
  if (!acc) { return;}

  acc.forEach(el => {
    el.addEventListener('change', ev => {
      const panels = ev.target.parentElement.children.filter(p => {
        return p.classList.contains('accordion__section');
      });
      const panel = panels[0];

      ev.target.setAttribute('aria-expanded', ev.target.checked);
      if (ev.target.checked) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      } else {
        panel.style.maxHeight = null;
      }
    });
  });
}
